const assignedCircleStyles = {
	none: 'fa-regular fa-circle',
	part: 'fa-solid fa-circle-half-stroke',
	full: 'fa-solid fa-circle'
}

type AssignedCircleStyleKey = keyof typeof assignedCircleStyles

export function getAssignedIconClass(status: string): string {
	return assignedCircleStyles[status as AssignedCircleStyleKey] || assignedCircleStyles.none
}
